if (!customElements.get('notification-layer')) {
    class NotificationLayer extends HTMLElement {
        constructor() {
            super()
        }

        EventUnSubscriber = undefined
        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            theme.Notifications = this
            this.CloseNode = this.querySelector('[data-close]')
            this.NotificationTarget = this.querySelector('[data-notification-target]')
            this.EventUnSubscriber = SubscribeToEvent(`Notify`, (eventData) => {
                this.OnEvent(eventData)
            })
        }
        disconnectedCallback() {
            if (this.EventUnSubscriber) {
                this.EventUnSubscriber()
            }
        }
        async OnEvent(eventData) {
            await this.CreateNotification(eventData)
            this.OpenOverlay()
        }
        async CreateNotification(payload) {
            const NotificationDiv = document.createElement('div')
            NotificationDiv.className = 'Notification'
            NotificationDiv.setAttribute('data-type', payload.Type || '')

            // If Title is present in the payload, create and append the Title div
            if (payload.Title) {
                const TitleDiv = document.createElement('div')
                TitleDiv.className = 'Title'
                TitleDiv.innerText = payload.Title
                NotificationDiv.appendChild(TitleDiv)
            }

            // If Description is present in the payload, create and append the Description div
            if (payload.Description) {
                const DescriptionDiv = document.createElement('div')
                DescriptionDiv.className = 'Description'
                DescriptionDiv.innerHTML = payload.Description
                const links = DescriptionDiv.querySelectorAll('a');
                links.forEach(link => {
                    link.classList.add('Link');
                });
                NotificationDiv.appendChild(DescriptionDiv)
            }

            const CloseDiv = this.CloseNode.cloneNode(true)
            CloseDiv.addEventListener('click', () => this.RemoveNotification(NotificationDiv))
            NotificationDiv.appendChild(CloseDiv)

            // Inject Notification Into Target Container
            this.NotificationTarget.appendChild(NotificationDiv)
        }
        RemoveNotification(element) {
            this.NotificationTarget.removeChild(element);
            if(Array.from(this.NotificationTarget.children).length <= 0) {
                this.CloseOverlay()
            }
        }

        OpenOverlay() {
            theme?.Overlay?.ActivateLayer?.('Notifications')
        }
        CloseOverlay() {
            theme?.Overlay?.DeActivateOverlay?.()
        }
    }
    customElements.define('notification-layer', NotificationLayer)
}